import { render, staticRenderFns } from "./ManageEvaluationsView.vue?vue&type=template&id=0737ff81&scoped=true"
import script from "./ManageEvaluationsView.vue?vue&type=script&lang=js"
export * from "./ManageEvaluationsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0737ff81",
  null
  
)

export default component.exports